import React, { forwardRef, useCallback, useContext, useEffect, useRef } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { PostEditorContext } from '../states/PostEditorProvider';
import { GetLinkMetadataQuery } from '../../../models/graphql';
import { PostEditorBulkImportGroupElement } from '../PostEditorBulkImportGroupElement';
import { useClosePostEditor } from '../../../hooks/useClosePostEditor';

export type PostEditorBulkImportGroupsViewProps = {
  //
  formInstance: UseFormReturn;
  linksMetadata: undefined | GetLinkMetadataQuery['linkMetadata'];
};

export const PostEditorBulkImportGroups = forwardRef<HTMLDivElement | null, PostEditorBulkImportGroupsViewProps>(
  (props, ref): JSX.Element => {
    const { formInstance, linksMetadata } = props;
    const { dispatch, state, initialized } = useContext(PostEditorContext);
    const { closePostEditor } = useClosePostEditor();
    const postGroupsCounter = state ? state.postGroups.length : 0;
    const activePostGroupsCounter = state ? state.postGroups.filter(g => !g.deleted).length : 0;
    const activePostGroupIndex = useRef<number | null>(null);

    //when we fetch group links metadata wee need to update the post editor state with that
    useEffect(() => {
      if (linksMetadata && initialized) {
        dispatch({ type: 'bulkImportSetLinkMetadata', payload: linksMetadata });
      }
    }, [linksMetadata, initialized, dispatch]);

    const removeGroupAction = useCallback(
      (index: number) => {
        activePostGroupIndex.current = index;
        activePostGroupsCounter < 2 ? closePostEditor() : dispatch({ type: 'removePostGroup', payload: index });
      },
      [dispatch, activePostGroupsCounter, closePostEditor]
    );

    const elements: JSX.Element[] = [];
    let counter = 0;
    for (let i = 0; i < postGroupsCounter; i++) {
      // push the component to elements!
      if (!state.postGroups[i].deleted) {
        counter++;
        elements.push(
          <PostEditorBulkImportGroupElement
            counter={counter}
            index={i}
            formInstance={formInstance}
            removeGroupAction={removeGroupAction}
            key={`group-index-provider-${i}`}
          />
        );
      }
    }
    return <div ref={ref}>{elements}</div>;
  }
);
